import Image from '@/components/ui/Image';

export function PontificiaIcon() {
  return (
    <Image 
      src="/images/pontificia.svg" 
      alt="Título Pontificio" 
      width={32} 
      height={32} 
      className="drop-shadow-md"
    />
  );
}
